import { Text, Icon, Tooltip, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

interface InfoTooltipProps {
  text: string;
}

const TOOLTIP_LABEL =
  'Atenção: Clientes com erro não serão\nincluídos na lista de envio de boletas. Para\ncorrigir, exporte os dados, realize os\najustes necessários e importe um novo\nlote.';

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => (
  <Tooltip hasArrow placement="bottom left" label={TOOLTIP_LABEL}>
    <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
      <Icon name="Info" size="xxs" color={Color['brand.tertiary.principal']} />
      <Text color="neutral.darkest">{text}</Text>
    </HStack>
  </Tooltip>
);
